<template>
  <div class="ts-p-3 ts-rounded">
    <div class="ts-grid ts-grid-cols-1 xl:ts-grid-cols-4 ts-gap-3">
      <div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.currentStatus') }}:</p>
        <p class="ts-border ts-to-blue-600 ts-rounded ts-p-1">
          <strong
            :class="
              value.sn_status_id == 1 ? 'ts-text-blue-600' : 'ts-text-red-600'
            "
            >{{ value.sn_status }}</strong
          >
        </p>
      </div>
      <div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.currentWarehouse') }}:</p>
        <p>
          <strong>{{ value.location_name_en }}</strong>
        </p>
      </div>
			<div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.previousWarehouse') }}:</p>
        <p>{{ value.previous_location_name_en }}</p>
      </div>
			<div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.grade') }}:</p>
        <p>
          <strong>{{ value.product_grade }}</strong>
        </p>
      </div>
			<div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.previousStatus') }}:</p>
        <p>{{ value.pevious_sn_status }}</p>
      </div>
      <div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.returnToVendorNumber') }}:</p>
        <p>
					<strong>{{ value.return_to_vendor_number }}</strong>
				</p>
      </div>
      <div class="ts-flex ts-space-x-3 ts-items-center">
        <p>{{ $t('productProfile.returnFromVendorNumber') }}:</p>
        <p>
					<strong>{{ value.return_from_vendor_number }}</strong>
				</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
	props: ['value']
}
</script>